import type { Film } from '@vista-digital/ocapi-types/v1'
import { useMemo } from 'react'
import type { EventDetailFilmConfigPropsApi } from '@/pages/eventDetails/models'

export const useDeferredDate = (film: Film, deferredDateData: EventDetailFilmConfigPropsApi[]): Date | null => {
    const filmId = film?.id

    return useMemo(() => {
        if (!filmId || !deferredDateData?.length) return null

        const match = deferredDateData.find(({ film: deferredFilm }) => {
            return deferredFilm?.key === filmId
        })

        return match?.deferredDate ?? null
    }, [filmId, deferredDateData])
}
